// src/hooks/useLeadSourceCache.js
import leadSourceService from "../components/Services/LeadSourceService";

const LEAD_SOURCE_KEY = "leadSources";
const LAST_UPDATED_KEY = "leadSourcesLastUpdated";
const THIRTY_MINUTES = 5 * 60 * 1000;

export const fetchAndCacheLeadSources = async () => {
  try {
    const now = Date.now();
    const lastUpdated = localStorage.getItem(LAST_UPDATED_KEY);

    if (lastUpdated && now - parseInt(lastUpdated, 10) < THIRTY_MINUTES) {
      return;
    }

    const res = await leadSourceService.getAllLeadSource();
    const data = res.data.leadSources;

    localStorage.setItem(LEAD_SOURCE_KEY, JSON.stringify(data));
    localStorage.setItem(LAST_UPDATED_KEY, now.toString());

  } catch (error) {
    console.error("Failed to fetch lead sources:", error);
  }
};

export const getLeadSourcesFromCache = () => {
  const data = localStorage.getItem(LEAD_SOURCE_KEY);
  return data ? JSON.parse(data) : [];
};
